// Shared parsing helpers for catalog imports, used by the browser import
// (AdminItemCatalog) and the bulk loader so both clean files identically.

// Strip Excel's text-format wrapper: ="00002" -> 00002 (preserves leading zeros).
export function unwrapExcel(v) {
  const s = (v == null ? '' : String(v)).trim();
  const m = s.match(/^="(.*)"$/s);
  return m ? m[1].trim() : s;
}

// Decode an uploaded catalog file's bytes. Handles UTF-16 (BOM or null-byte
// heuristic, e.g. the ClaimSoft export) and falls back from UTF-8 to
// Windows-1252 for legacy latin1 exports (e.g. the AccountEdge list).
export function decodeCatalogBytes(buf) {
  const bytes = new Uint8Array(buf);
  if (bytes.length >= 2) {
    if (bytes[0] === 0xff && bytes[1] === 0xfe) return new TextDecoder('utf-16le').decode(bytes);
    if (bytes[0] === 0xfe && bytes[1] === 0xff) return new TextDecoder('utf-16be').decode(bytes);
  }
  // No BOM: sniff for UTF-16 via null bytes. ASCII in UTF-16LE puts the null
  // at odd byte offsets, UTF-16BE at even offsets.
  const sniff = bytes.subarray(0, Math.min(bytes.length, 4000));
  let evenNul = 0, oddNul = 0;
  for (let i = 0; i < sniff.length; i++) {
    if (sniff[i] === 0x00) { if (i % 2 === 0) evenNul++; else oddNul++; }
  }
  if (oddNul > sniff.length / 8)  return new TextDecoder('utf-16le').decode(bytes);
  if (evenNul > sniff.length / 8) return new TextDecoder('utf-16be').decode(bytes);
  // Try UTF-8; if it produced replacement chars, fall back to Windows-1252.
  const utf8 = new TextDecoder('utf-8').decode(bytes);
  return utf8.indexOf('�') !== -1 ? new TextDecoder('windows-1252').decode(bytes) : utf8;
}

// Drop template marker lines (#...) and any export preamble that appears before
// the real header row (ClaimSoft prepends company info above "ItemNumber,...").
export function stripToHeader(text) {
  let lines = text.split(/\r?\n/).filter(l => !l.trimStart().startsWith('#'));
  const headerIdx = lines.findIndex(l => /(^|[,\t])\s*(ItemNumber|Item Number|item_number)\s*([,\t]|$)/i.test(l));
  if (headerIdx > 0) lines = lines.slice(headerIdx);
  return lines.join('\n');
}
